// eslint-disable-next-line no-restricted-syntax
export enum ChannelContestFilter {
  ALL = 'ALL',
  NOT_YET_STARTED = 'NOT_YET_STARTED',
  STARTED = 'STARTED',
  FINAL = 'FINAL',
}
